<template>
  <div class="viewer">
    <div class="mainImage">
      <div class="controls">
        <button class="btn-arrow" id="left" @click="arrowControls()"><</button>
        <img :src="currentImage" />
        <button class="btn-arrow" id="right" @click="arrowControls()">></button>
      </div>
      <input
        ref="range"
        type="range"
        min="0"
        :max="currentSeries.instances.length - 1"
        step="1"
        @input="changeImage()"
      />
    </div>
    <div class="series" ref="options">
      <div :key="serie.pk" v-for="serie in series">
        <div
          class="instance-block"
          :style="`background-image: url(${serie.instances[0].url})`"
          :id="serie.pk"
          @click="changeSeries()"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "imgViewer",
  props: ["series"],
  data() {
    return {
      currentImage: null,
      currentSeries: null
    };
  },
  mounted() {
    this.currentImage = this.series[0].instances[0].url;
    this.currentSeries = this.series[0];
  },
  methods: {
    changeImage() {
      this.currentImage = this.currentSeries.instances[
        this.$refs.range.value
      ].url;
    },
    changeSeries() {
      let el = event.target;
      for (var i = 0; i < this.series.length; i++) {
        if (this.series[i].pk == el.id) {
          this.currentSeries = this.series[i];
        }
      }
      this.updateMainImage(this.currentSeries);
    },
    updateMainImage(series){
      this.currentImage = this.currentSeries.instances[0].url;
      this.$refs.range.value = 0;
    },
    arrowControls() {
      if (event.target.id == "right") {
        this.$refs.range.value = parseInt(this.$refs.range.value) + 1;
        this.changeImage();
        
      } else if (event.target.id == "left") {
        this.$refs.range.value = parseInt(this.$refs.range.value) - 1;
        this.changeImage();
      }
    }
  }
};
</script>

<style scoped lang="scss">
img {
  max-height: 60vh;
  max-width: 90%;
}
input[type="range"] {
  width: 175px;
  height: 45px;
}

.arrow-controls {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 10px 0;
}

.arrow-controls .left,
.arrow-controls .right {
  background-color: white;
  border-radius: 5px;
  font-weight: 300;
  height: 50px;
  width: 30px;
  margin-right: 5px;
}

.instance-block {
  width: 150px;
  height: 100px;
  border-radius: 4px;
  border: 1px solid black;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 5px;
  cursor: pointer;
}
.series {
  margin: 10px 0;
  display: flex;
  align-items: center;
  overflow-x: scroll;
}

.mainImage {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btn-arrow {
  background-color: white;
  border-radius: 5px;
  font-weight: 300;
  height: 50px;
  width: 30px;
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/imageViewer.vue